document.addEventListener("DOMContentLoaded", function () {
    function resizeListener() {
      var targets = document.querySelectorAll(".js-add-shadow");
  
      targets.forEach(function (target) {
        var isOverflowing = target.scrollWidth > target.offsetWidth;
        var parent = target.parentElement;
  
        if (isOverflowing) {
          parent.classList.add("shadow");
        } else {
          parent.classList.remove("shadow");
        }
      });
    }
  
    window.addEventListener("load", resizeListener);
    window.addEventListener("resize", resizeListener);
  });
  